export enum AnalyticsGroupType {
  Subscription = 'subscription id',
}
